import { Box } from "../box";
import { type StackProps } from "./types";
import { spacing } from "@repo/tokens";

export const HStack = ({
  gap,
  align,
  justify,
  style,
  ...props
}: StackProps) => {
  return (
    <Box
      flexDirection="row"
      alignItems={align}
      justifyContent={justify}
      style={{
        gap: gap ? spacing[gap] : undefined,
        ...(style as React.CSSProperties),
      }}
      {...props}
    />
  );
};

export const VStack = ({
  gap,
  align,
  justify,
  style,
  ...props
}: StackProps) => {
  return (
    <Box
      flexDirection="column"
      alignItems={align}
      justifyContent={justify}
      style={{
        gap: gap ? spacing[gap] : undefined,
        ...(style as React.CSSProperties),
      }}
      {...props}
    />
  );
};
